function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

import PropTypes from 'prop-types';
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import { Field, useForm } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var RANGE_EXACT = "exact";
export var RANGE_BETWEEN = "between";
export var RANGE_AFTER = "after";
export var RANGE_BEFORE = "before";
export var RANGE_ABOUT = "about";
export var DEFAULT_RANGE = RANGE_BETWEEN;
export var DEFAULT_YEAR_PLUS_MINUS = 5;
export function DateRangeGroup(_ref) {
  var disabled = _ref.disabled; // TODO missing label

  var intl = useIntl();
  var form = useForm();
  var type = form.getState().values.rangeType;
  return /*#__PURE__*/_jsxs(InputGroup, {
    children: [/*#__PURE__*/_jsx(Field, {
      name: "rangeType",
      render: function render(_ref2) {
        var input = _ref2.input;
        return /*#__PURE__*/_jsxs(Form.Control, _objectSpread(_objectSpread({
          as: "select",
          custom: true,
          disabled: disabled
        }, input), {}, {
          children: [/*#__PURE__*/_jsx("option", {
            value: RANGE_EXACT,
            children: intl.formatMessage({
              id: 'form.period.exact'
            })
          }), /*#__PURE__*/_jsx("option", {
            value: RANGE_BETWEEN,
            children: intl.formatMessage({
              id: 'form.period.between'
            })
          }), /*#__PURE__*/_jsx("option", {
            value: RANGE_AFTER,
            children: intl.formatMessage({
              id: 'form.period.after'
            })
          }), /*#__PURE__*/_jsx("option", {
            value: RANGE_BEFORE,
            children: intl.formatMessage({
              id: 'form.period.before'
            })
          }), /*#__PURE__*/_jsx("option", {
            value: RANGE_ABOUT,
            children: intl.formatMessage({
              id: 'form.period.about'
            })
          })]
        }));
      }
    }), (type === RANGE_EXACT || type === RANGE_ABOUT || type === RANGE_AFTER || type === RANGE_BEFORE) && /*#__PURE__*/_jsx(Field, {
      name: "year",
      render: function render(_ref3) {
        var input = _ref3.input;
        return /*#__PURE__*/_jsx(FormControl, _objectSpread({
          type: "number",
          placeholder: intl.formatMessage({
            id: 'form.year'
          }),
          disabled: disabled
        }, input));
      }
    }), type === RANGE_BETWEEN && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Field, {
        name: "yearAfter",
        render: function render(_ref4) {
          var input = _ref4.input;
          return /*#__PURE__*/_jsx(FormControl, _objectSpread({
            type: "number",
            placeholder: intl.formatMessage({
              id: 'form.year'
            }),
            disabled: disabled
          }, input));
        }
      }), /*#__PURE__*/_jsx(Field, {
        name: "yearBefore",
        render: function render(_ref5) {
          var input = _ref5.input;
          return /*#__PURE__*/_jsx(FormControl, _objectSpread({
            type: "number",
            placeholder: intl.formatMessage({
              id: 'form.year'
            }),
            disabled: disabled
          }, input));
        }
      })]
    }), type === RANGE_ABOUT && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "input-group-prepend input-group-append",
        children: /*#__PURE__*/_jsx("span", {
          className: "input-group-text user-select-none",
          children: "\xB1"
        })
      }), /*#__PURE__*/_jsx(Field, {
        name: "yearPlusMinus",
        render: function render(_ref6) {
          var input = _ref6.input;
          return /*#__PURE__*/_jsx(FormControl, _objectSpread({
            type: "number",
            placeholder: intl.formatMessage({
              id: 'form.years_amount'
            }),
            min: 0,
            disabled: disabled
          }, input));
        }
      })]
    })]
  });
}
DateRangeGroup.propTypes = {
  disabled: PropTypes.bool.isRequired
};